import { API_URL } from '../config/api';

const getAuthHeader = () => {
    const token = localStorage.getItem('authToken');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

const firmService = {
    async getAllFirms() {
        const response = await fetch(`${API_URL}/firms`, {
            headers: getAuthHeader(),
        });
        if (!response.ok) {
            throw new Error('Failed to fetch firms');
        }
        return response.json();
    },

    async getFirmById(id) {
        const response = await fetch(`${API_URL}/firms/${id}`, {
            headers: getAuthHeader(),
        });
        if (!response.ok) {
            throw new Error('Failed to fetch firm');
        }
        return response.json();
    },

    async createFirm(firmData) {
        const response = await fetch(`${API_URL}/firms`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader(),
            },
            body: JSON.stringify(firmData),
        });
        if (!response.ok) {
            throw new Error('Failed to create firm');
        }
        return response.json();
    },

    async updateFirm(id, firmData) {
        const response = await fetch(`${API_URL}/firms/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader(),
            },
            body: JSON.stringify(firmData),
        });
        if (!response.ok) {
            throw new Error('Failed to update firm');
        }
        return response.json();
    },

    async deleteFirm(id) {
        const response = await fetch(`${API_URL}/firms/${id}`, {
            method: 'DELETE',
            headers: getAuthHeader(),
        });
        if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data.error || 'Failed to delete firm');
        }
        return true;
    },

    async getAllStrategies() {
        const response = await fetch(`${API_URL}/strategies`, {
            headers: getAuthHeader(),
        });
        if (!response.ok) {
            throw new Error('Failed to fetch strategies');
        }
        return response.json();
    },

    async getAllCities() {
        const response = await fetch(`${API_URL}/cities`, {
            headers: getAuthHeader(),
        });
        if (!response.ok) {
            throw new Error('Failed to fetch cities');
        }
        return response.json();
    },
    
    async bulkCreateFirms(firms) {
        const response = await fetch(`${API_URL}/firms/bulk`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader(),
            },
            body: JSON.stringify({ firms }),
        });
        if (!response.ok) {
            throw new Error('Failed to import firms');
        }
        return response.json();
    },
};

export default firmService;
